module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fc-Hc-Id-Ja.b7e17507.png";